export enum FormFields {
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  reason = 'reason',
  customerNumber = 'customerNumber',
  orderNumber = 'orderNumber',
  description = 'description',
  attachment = 'attachment',
}
